module.exports = __webpack_public_path__ + "static/media/kod_girisi_ADIM1.782ee04f.jpg";